import React, { useCallback, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import StepperVertical from '../../components/Stepper/StepperVertical';
import { useAppSelector } from '../../hooks/useRedux';
import GridLabels from '../VehicleTabs/GridLabels';
import TabLoader from '../VehicleTabs/TabLoader';
import { getVehicleOrder } from '../../services/order';
import useMetaData from '../../hooks/useMetaData';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import { jsonPathToValue } from '../../utils/json';
import { lifeCycleSnapshot } from '../../services/vehicles';
import { contentType, handleContent } from '../Reservation';

const Order = () => {
  //  use hooks
  const { reservationId } = useParams<{ reservationId: string }>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.orderTab);
  const lifecycleMeta = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.LifeCycleSnapShot);

  // local states
  const [data, setData] = useState<any>();
  const [orderData, setOrderData] = useState<any>(null);

  // global states
  // const vehicleData = useAppSelector((state) => state.vehicle?.data);

  // constants
  const stepsVertical = orderData?.stageInformation
    ?.sort((a: any, b: any) => parseFloat(b?.sequence) - parseFloat(a?.sequence))
    ?.filter(
      (fil: { ruleResult: { isCompleted: boolean }; subStage: string; showSubStage: boolean }) => fil?.showSubStage
    )
    ?.map((item: any) => {
      return {
        id: '1',
        label: (
          <Typography variant="body2" fontWeight={600}>
            {lifecycleMeta?.fields?.[item?.subStage]?.caption}
          </Typography>
        ),
        content: <>{handleContent(item?.ruleResult, lifecycleMeta?.fields?.[item?.subStage])}</>,
        isCompleted: item?.ruleResult?.isCompleted,
      };
    });

  const orderFields = useMemo(
    () =>
      data
        ? metaData?.order?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property) || '';
            return {
              label: row?.propertyName,
              title: value || '--',
              type: row.type,
            };
          }) || []
        : [],
    [data, metaData]
  );

  // fetching record
  const fetchOrderData = useCallback(async () => {
    try {
      const resp = await lifeCycleSnapshot({
        method: 'POST',
        data: {
          reservationId,
          stages: ['Ordered'],
          langCode: 'en-us',
        },
      });
      setOrderData(resp?.data?.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }, [reservationId]);

  // lifecycle hook
  useEffect(() => {
    if (reservationId) {
      getVehicleOrder(reservationId).then((response) => setData(response || {}));
      fetchOrderData();
    }
  }, [reservationId, fetchOrderData]);

  if (!data)
    return (
      <Box sx={{ position: 'relative', minHeight: '250px' }}>
        <CircularProgress
          color="inherit"
          size={18}
          sx={{ position: 'absolute', left: '0', right: '0', top: '50%', margin: '0 auto' }}
        />
      </Box>
    );
  return (
    <Box>
      <Typography fontSize={20} mb={1.2} fontWeight={500} lineHeight="24px">
        Order Lifecycle
      </Typography>
      <Grid item xs={12} mb={1}>
        <Divider sx={{ borderColor: '#E9E9E9' }} />
      </Grid>
      <StepperVertical steps={stepsVertical} activeStep={stepsVertical?.length ?? 10} />
      <Box sx={{ width: '100%', my: 4 }}>
        <Typography fontSize={14} mb={1} fontWeight={500}>
          Order Details
        </Typography>
        <Divider sx={{ borderColor: '#e3e3e3', borderStyle: 'dashed' }} />
        <Grid container spacing={2} mt={0}>
          <GridLabels
            labels={orderFields}
            labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
            titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
          />
        </Grid>
      </Box>
    </Box>
  );
};
export default Order;
